import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router/index'

axios.tempGet = axios.get
axios.defaults.timeout = 60000
axios.get = (url, data, config) => {
  data = data || {}
  const params = data.params || data
  return axios.tempGet(url, { params: params, ...config })
}

const whiteList = ['/v2/document/addbyfile']
axios.interceptors.request.use(config => {
  if (store.state.token && !whiteList.includes(config.url)) {
    config.headers.token = store.state.token
  }
  if (config.method === 'get') {
    for (const key in config.params) {
      if (config.params[key] === '') {
        config.params[key] = null
      }
    }
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

// 按实际响应类型处理下载，新增导出接口无需维护地址白名单。
function isFileResponse(response) {
  return ['blob', 'arraybuffer'].includes(response.config.responseType) ||
    response.data instanceof Blob || response.data instanceof ArrayBuffer
}

async function readFileError(response) {
  const data = response.data
  const contentType = ((response.headers || {})['content-type'] || (data && data.type) || '').toLowerCase()
  if (data && typeof data === 'object' && !(data instanceof Blob) && !(data instanceof ArrayBuffer)) {
    return data
  }
  if (!contentType.includes('json') && !contentType.startsWith('text/')) return null
  const text = data instanceof Blob ? await data.text()
    : data instanceof ArrayBuffer ? new TextDecoder('utf-8').decode(data) : data
  try {
    return JSON.parse(text) || { message: '导出失败：服务器未返回有效文件' }
  } catch (error) {
    // CSV、文本附件仍允许下载；JSON 或 HTML 错误页不能伪装成文件。
    if (!contentType.includes('json') && !contentType.includes('html') && (response.headers || {})['content-disposition']) return null
    return { message: '导出失败：服务器未返回有效文件' }
  }
}

function rejectResponse(data, response, fallback = '请求失败') {
  const error = new Error((data && data.message) || fallback)
  error.code = data && data.code
  Message({ message: error.message, type: 'error', duration: 5 * 1000 })
  // 旧请求的失效通知不能注销用户随后建立的新会话。
  const requestToken = response && response.config.headers && response.config.headers.token
  if (Number(error.code) === 100000 && (!requestToken || requestToken === store.state.token)) {
    store.commit('resetSession')
    if (router.currentRoute.path !== '/login') router.replace('/login')
  }
  return Promise.reject(error)
}

axios.interceptors.response.use(async response => {
  const res = response.data
  if (isFileResponse(response)) {
    const errorData = await readFileError(response)
    if (errorData !== null) return rejectResponse(errorData, response, '导出失败')
    return response
  }
  if (response.config.url.includes('/v2')) return res
  if (!res || res.code !== 200) return rejectResponse(res, response)
  // 财务推送等接口还需判断业务结果，可由调用方关闭通用成功提示，避免失败时先弹出“操作成功”。
  if (response.config.method === 'post' && response.config.showSuccessMessage !== false) {
    const urls = ['/mclz/login', '/mclz/course/addCourseNum']
    if (!urls.includes(response.config.url)) Message({ type: 'success', message: res.message })
  }
  return res.data
}, async error => {
  const response = error.response
  if (response) {
    const data = isFileResponse(response) ? await readFileError(response) : response.data
    return rejectResponse(data, response, error.message)
  }
  return rejectResponse(null, null, error.message)
})

export default axios
